export default "__VITE_ASSET__2a8c5c37__"